export class VisibilitySwitchComponent {
    readonly active = 'active';
    private featuresItemActions: HTMLElement[] ;

    constructor(
        private container: HTMLElement
    ) {
        this.featuresItemActions
            = Array.prototype.slice.call(this.container.querySelectorAll('[data-visibility-switch-control]'));
    }
    public initialize(): void {
        this.featuresItemActions.forEach((fia: HTMLElement) => {
            fia.addEventListener('click', () => {
                fia.querySelectorAll('[data-visibility-switch-item-btn]')
                    .forEach((btn: Element): void => {
                    btn.classList.toggle(this.active);
                });
                fia.classList.toggle(this.active);
                this.container.classList.toggle(this.active);
            });
        });
    }
}
